<template>
  <div class="print-list_box">
    <el-tabs type="border-card" class="y-b-0" v-model="activeTab">
      <el-tab-pane label="平台回收明细" name="ecomdetail">
        <pDetail v-if="activeTab === 'ecomdetail'" />
      </el-tab-pane>
      <el-tab-pane label="客户编码回收明细" name="kdetail">
        <kDetail v-if="activeTab === 'kdetail'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  components: {
    kDetail: () => import('./kDetail.vue'),
    pDetail: () => import('./pDetail.vue')
  },
  data() {
    return {
      activeTab: 'ecomdetail'
    }
  },
  mounted() {
    // 非当前页跳转
    if (this.$route.params.fromPage == 'gpt') {
      this.activeTab = 'kdetail';
    }
    // 从gpt跳转过来的--当前页二次跳转
    this.bus.$off("addParams_surfaceRecycledtail").$on('addParams_surfaceRecycledtail', (txt) => {
      this.activeTab = 'kdetail';
      localStorage.setItem('surfaceRecycledtailParams', JSON.stringify(txt));
    })
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-tabs__item.is-active {
  border: 1px solid #fff !important;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
/deep/ .el-tabs__item {
  color: #666;
}
/deep/ .el-tabs__header {
  background-color: #F0F2F8 !important;
}
</style>
